import Div100vh from 'react-div-100vh';
import { CSSProperties, ComponentProps } from 'react';
import styles from './ScreenCover.module.scss';

type ScreenCoverProps = ComponentProps<typeof Div100vh> & {
	coverOpacity?: string;
	coverColor?: string;
	zIndex?: number;
};

export const ScreenCover = ( {
	coverOpacity,
	coverColor,
	onClick,
	zIndex = 10,
	...childProps
}: ScreenCoverProps ) => {
	const style = {
		'--screen-cover-opacity': coverOpacity || '0.7',
		'--screen-cover-background': coverColor || '#000',
		'--screen-cover-z-index': zIndex,
	} as CSSProperties;

	return (
		<div className={ styles.screenCover } style={ style } onClick={ onClick }>
			<Div100vh { ...childProps } />
		</div>
	);
};
